//axios
import axios from 'axios';
//url util for api calls
import { url } from 'utils/urls';

const withCredentials = true;
const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };

// TODO Remove getSites
export const getSites = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}/sites?filterRonSites=false`, { withCredentials });
export const getCountries = paramString => axios.get(`${url.ppa.accounts}/${paramString}`, { withCredentials });

export const asyncGetAllQuestionsAnswered = paramString => axios.post(`${url.ppa.metrics.questionAnswered}/total`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetTotalTopQuestionsAnswered = paramString => axios.post(`${url.ppa.metrics.questionAnswered}/top-questions`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetTotalAverageInView = paramString => axios.post(`${url.ppa.metrics.embedLoad}/total`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetTotalUniqueEngagedUsers = paramString => axios.post(`${url.ppa.metrics.uniqueEngagedUsers}/total`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetTopStories = paramString => axios.post(`${url.ppa.metrics.storyClicked}/top-stories`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetTotalStoryClicks = paramString => axios.post(`${url.ppa.metrics.storyClicked}/total`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetTotalRevenueMetrics = paramString => axios.post(`${url.rms.metrics.revenue}/total`, encodeURI(paramString), { headers, withCredentials });
